import Types from "./../constants/cities";

const defaultState = {
  list: null,
  defaultCity: null,
  selectedOffice: null,
  selectedGroup: null,
  selectedCity: null,
  offices: null,
  groups: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case Types.DATA:
      return { ...state, ...action.cities };
    default:
      return state;
  }
};
